import React from "react";

import Strategies from "src/pages/Analysis/Config/SWOTStrategy";
import MarketShare from "src/pages/Analysis/MarketShare";
import MatrizBCG from "src/pages/Analysis/MatrizBCG";
import AnalysisPanel from "src/pages/Analysis/Panel";
import BCGItems from "../pages/Analysis/Config/BCGItems";
import RoutePrivate from "./private";
import Competitors from "../pages/Analysis/Config/Competitors";
import Dimensions from "../pages/Analysis/Config/Dimensions";
import SWOT from "../pages/Analysis/SWOT";

export default [
	<RoutePrivate path="/analysis/panel" key="analysis" exact component={AnalysisPanel} isPrivate />,
	<RoutePrivate path="/analysis/competitors" key="analysisCompetitors" exact component={Competitors} isPrivate/>,
	<RoutePrivate path="/analysis/bcgitems" key="analysisBcgitems" exact component={BCGItems} isPrivate/>,
	<RoutePrivate path="/analysis/dimensions" key="analysisDimensions" exact component={Dimensions} isPrivate/>,
	<RoutePrivate path="/analysis/swot" key="analysisSwot" exact component={SWOT} isPrivate/>,
	<RoutePrivate path="/analysis/swot/:swotId" permissionPath="/analysis/swot" key="analysisSwotWithId" exact component={SWOT} isPrivate/>,
	<RoutePrivate path="/analysis/swotstrategy" key="swotStrategy" exact component={Strategies} isPrivate/>,
	<RoutePrivate path="/analysis/marketshare" key="marketShare" exact component={MarketShare} isPrivate/>,
	<RoutePrivate path="/analysis/matrizbcg" key="analysisMatrizBcg" exact component={MatrizBCG} isPrivate/>
];
